import styles from "@/../sass/components/MyModuleCard.module.scss"
import i18n from "i18next";
import ModuleCard from "@/Components/ModuleCard";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import {ButtonSecondary} from "@/Components/Buttons/ButtonSecondary";
import {useEffect, useReducer, useState} from "react";
import GeneralPurchaseModal from "@/Pages/BuyFlow/GeneralPurchaseModal";
import {Inertia} from "@inertiajs/inertia";
import { navigateToURL} from '@/Utilities/Util';
import {usePage} from "@inertiajs/inertia-react";

function reducer(state, action) {
    switch(action.type) {
        case "showCheckoutModal":
            return { ...state, showCheckoutModal: action.payload.showCheckoutModal }
        default:
            return state;
    }
}

export default function MyModuleCard({module, isActive, existingPayingCustomer}) {
    const [activeTag, setActiveTag] = useState({
        style: styles.isActive,
        text: i18n.t("organization-account.state.active")
    })

    const [disableStartTrial, setDisableStartTrial] = useState(false);

    const [state, dispatch] = useReducer(reducer, {
        showCheckoutModal: false
    });

    const isTrialOnly = module?.status === 2;
    const isActiveModule = isActive && ! isTrialOnly;
    const isActiveTrial = isActive && isTrialOnly;
    const isExpiredTrial = module?.trial?.expired_trial;
    const salesloftURL = usePage().props.salesloft_url;

    useEffect(() => {
        // ensure it's truly a trial and not converted
        if (module.trial && ! module.trial.converted_at) {
            setActiveTag({
                ...activeTag,
                style: styles.isTrial,
                text: module.trial.days_remaining > 0 ? i18n.t('organization-account.state.trial.active') : i18n.t('organization-account.state.trial.expired')
            })
        }
        return () => setDisableStartTrial(false);
    }, []);

    function startTrial() {
        Inertia.post(
            route('organization.add-modules.store'),
            {modules: [module.uuid]},
            { onSuccess: () => setDisableStartTrial(false)}
        );
    }

    return (
        <div key={module.uuid} className={styles.moduleWrap}>
            <div className={styles.module}>
                <div className={styles.moduleLogo}>
                    <ModuleCard
                        module={module}
                        interactive={false}
                        hoverable={false}
                        startingState={isActive}
                        showCheck={false}
                        useModuleSalesName={true}
                    ></ModuleCard>
                </div>
                <div className={styles.moduleDetails}>
                    <div className={styles.titleWrap}>
                        <div className={styles.title} dangerouslySetInnerHTML={{__html: module.sales_name ? module_sales_name : module.name}}/>
                        {isActive && <div
                            className={`${styles.status} ${activeTag.style}`}
                        >
                            {activeTag.text}
                        </div>}
                        {!isActive && <div
                            className={`${styles.status} ${styles.isInactive}`}
                        >
                            {i18n.t("organization-account.state.inactive")}
                        </div>}
                    </div>
                    <div className={styles.extraWrap}>
                        <div>{module.description}</div>
                        {isActiveModule && (
                            <div className={styles.support}>
                                <a href="https://help.myamplify.io/hc/en-us/requests/new">
                                    {i18n.t('organization-account.contact-us')}
                                </a>&nbsp;
                                {i18n.t('organization-account.for-questions')}
                            </div>)
                        }
                        {isActiveTrial && (
                            <div className={styles.activateWrap}>
                                <ButtonPrimary
                                    onClick={() => { !salesloftURL ?
                                        dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                                    }}
                                    className={styles.subscribe}>{i18n.t('organization-account.subscribe')}
                                </ButtonPrimary>
                            </div>)
                        }
                        {!isActive && (
                            <div className={styles.activateWrap}>
                                <ButtonPrimary
                                    onClick={() => { !salesloftURL ?
                                        dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                                    }}
                                    className={styles.subscribe}>{i18n.t('organization-account.subscribe')}
                                </ButtonPrimary>
                                {!isExpiredTrial && (
                                    <ButtonSecondary
                                        onClick={() => {
                                            setDisableStartTrial(true);
                                            startTrial();
                                        }}
                                        disabled={disableStartTrial}
                                        iconLeft="fa-plus">{i18n.t('organization-account.start-trial')}
                                    </ButtonSecondary>)
                                }
                            </div>
                        )}
                    </div>
                </div>
            </div>

            { state.showCheckoutModal ? <GeneralPurchaseModal state={state} dispatch={dispatch}/> : null }
        </div>
    );
}
